var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51287 11.375C2.2182 11.375 1.96879 11.2729 1.76462 11.0687C1.56046 10.8646 1.45837 10.6151 1.45837 10.3205V3.67949C1.45837 3.38483 1.56046 3.13542 1.76462 2.93125C1.96879 2.72708 2.2182 2.625 2.51287 2.625H11.4872C11.7818 2.625 12.0313 2.72708 12.2354 2.93125C12.4396 3.13542 12.5417 3.38483 12.5417 3.67949V10.3205C12.5417 10.6151 12.4396 10.8646 12.2354 11.0687C12.0313 11.2729 11.7818 11.375 11.4872 11.375H2.51287ZM7.00003 7.32528L11.6667 4.34131L11.5769 3.49999L7.00003 6.41665L2.42311 3.49999L2.33336 4.34131L7.00003 7.32528Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email_sent.fa08217141a443904e482dbc1d5bba9d.svg";
export { ForwardRef as ReactComponent };